
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { DeviceType, AppModule } from '@/store/modules/app';
import { formatTime } from '@/utils/index';
import html2canvas from 'html2canvas';
import { getAgentQrcode } from '@/api/agent';
var QRCode = require('qrcode');

@Component({
  name: 'NavbarAgent',
  components: {

  }
})
export default class extends Vue {
  private mobilenavbar = false;
  private qrCode = '';

  private defaultImgUrl = 'this.src="' + require('@/assets/images/default-avatar.png') + '"'

  get userInfo() {
    // TODO::获取用户信息
    return UserModule.user;
  }

  created() {
    this.getQR();
  }
  getQR() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.code = this.userInfo.alliance_code;
    getAgentQrcode(pamars).then(res => {
      this.qrCode = res.data;
    });
  }
  // 下载二维码
  handleDownload() {
    let code: any = document.querySelector('#qrCodeid');
    let filename = this.companyInfo && this.companyInfo.short_name ? this.companyInfo.short_name : this.companyInfo && this.companyInfo.name ? this.companyInfo.name : this.userInfo.name;
    code.style.width = '340px';
    code.style.height = '370px';
    code.style.fontSize = '25px';
    html2canvas(code as any).then(function(canvas:any) {
      let image = new Image();
      image.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
    code.style.width = '100%';
    code.style.height = 'auto';
    code.style.fontSize = '14px';
  }

  get companyInfo() {
    return UserModule.getCompany;
  }

  get device() {
    return AppModule.device;
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    };
  }

  // toggleSideBar() {
  //   AppModule.ToggleSideBar(false);
  // }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
